/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Win_Back_Paywall_Benefit_App_BlockInputs */

const en_win_back_paywall_benefit_app_block = /** @type {(inputs: Win_Back_Paywall_Benefit_App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time Guard`)
};

const ar_win_back_paywall_benefit_app_block = /** @type {(inputs: Win_Back_Paywall_Benefit_App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حارس الوقت`)
};

const de_win_back_paywall_benefit_app_block = /** @type {(inputs: Win_Back_Paywall_Benefit_App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitwächter`)
};

const es_win_back_paywall_benefit_app_block = /** @type {(inputs: Win_Back_Paywall_Benefit_App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardián del Tiempo`)
};

const fr_win_back_paywall_benefit_app_block = /** @type {(inputs: Win_Back_Paywall_Benefit_App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gardien du Temps`)
};

const it_win_back_paywall_benefit_app_block = /** @type {(inputs: Win_Back_Paywall_Benefit_App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time Guard`)
};

const ja_win_back_paywall_benefit_app_block = /** @type {(inputs: Win_Back_Paywall_Benefit_App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムガード`)
};

const ko_win_back_paywall_benefit_app_block = /** @type {(inputs: Win_Back_Paywall_Benefit_App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타임 가드`)
};

const pt_br_win_back_paywall_benefit_app_block = /** @type {(inputs: Win_Back_Paywall_Benefit_App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vigia do Tempo`)
};

const ru_win_back_paywall_benefit_app_block = /** @type {(inputs: Win_Back_Paywall_Benefit_App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контроль времени`)
};

const th_win_back_paywall_benefit_app_block = /** @type {(inputs: Win_Back_Paywall_Benefit_App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การปกป้องเวลา`)
};

const tr_win_back_paywall_benefit_app_block = /** @type {(inputs: Win_Back_Paywall_Benefit_App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaman Koruması`)
};

const zh_cn_win_back_paywall_benefit_app_block = /** @type {(inputs: Win_Back_Paywall_Benefit_App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间守护`)
};

const zh_tw_win_back_paywall_benefit_app_block = /** @type {(inputs: Win_Back_Paywall_Benefit_App_BlockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時間守護`)
};

/**
* | output |
* | --- |
* | "Time Guard" |
*
* @param {Win_Back_Paywall_Benefit_App_BlockInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const win_back_paywall_benefit_app_block = /** @type {((inputs?: Win_Back_Paywall_Benefit_App_BlockInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Win_Back_Paywall_Benefit_App_BlockInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_win_back_paywall_benefit_app_block(inputs)
	if (locale === "ar") return ar_win_back_paywall_benefit_app_block(inputs)
	if (locale === "de") return de_win_back_paywall_benefit_app_block(inputs)
	if (locale === "es") return es_win_back_paywall_benefit_app_block(inputs)
	if (locale === "fr") return fr_win_back_paywall_benefit_app_block(inputs)
	if (locale === "it") return it_win_back_paywall_benefit_app_block(inputs)
	if (locale === "ja") return ja_win_back_paywall_benefit_app_block(inputs)
	if (locale === "ko") return ko_win_back_paywall_benefit_app_block(inputs)
	if (locale === "pt_br") return pt_br_win_back_paywall_benefit_app_block(inputs)
	if (locale === "ru") return ru_win_back_paywall_benefit_app_block(inputs)
	if (locale === "th") return th_win_back_paywall_benefit_app_block(inputs)
	if (locale === "tr") return tr_win_back_paywall_benefit_app_block(inputs)
	if (locale === "zh_cn") return zh_cn_win_back_paywall_benefit_app_block(inputs)
	return zh_tw_win_back_paywall_benefit_app_block(inputs)
});